class UsanaLoggingService {
    static { this.loggingKey = 'USANA_DEV_LOGGING'; }
    static { this.loggingVal = 't'; }
    static logMsg(msg, skipStack = false) {
        if (this.isEnabled()) {
            this.log(msg, skipStack);
        }
    }
    static logFn(fn, skipStack = false) {
        if (this.isEnabled()) {
            this.log(fn(), skipStack);
        }
    }
    static isEnabled() {
        return this.hasStorage() && sessionStorage.getItem(this.loggingKey) === this.loggingVal;
    }
    static enable() {
        if (this.hasStorage()) {
            sessionStorage.setItem(this.loggingKey, this.loggingVal);
        }
    }
    static disable() {
        if (this.hasStorage()) {
            sessionStorage.removeItem(this.loggingKey);
        }
    }
    static hasStorage() {
        return !!Storage;
    }
    static log(msg, skipStack) {
        // log the message with an error stack (so we get the stack trace, but chop off the first 5 characters 'Error'
        const stackMsg = skipStack ? '' : new Error().stack.substr(5);
        console.log(this.loggingKey, msg, stackMsg);
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { UsanaLoggingService };
